import { memo } from 'react';

import Box from '@mui/material/Box';

import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';
import { ClusterPicker } from '../components';
import { Cluster, ClusterConfiguration, DEFAULT_CLUSTER } from '../types';

export interface ApplicationClusterSectionProps {
  value: ClusterConfiguration | null;
  availableClusters: Cluster[];
  onChange: (value: ClusterConfiguration | null) => void;
  errors: string[];
}

const ApplicationClusterSectionInner = ({
  value,
  availableClusters,
  onChange,
  errors,
}: ApplicationClusterSectionProps) => {
  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Cluster"
          description="Select the cluster and namespace for this Application."
          variant="h5"
          divider
        />
        <ClusterPicker
          value={value ?? DEFAULT_CLUSTER}
          clusters={availableClusters}
          onChange={onChange}
          errors={errors}
        />
      </ScaffolderFormPaper>
    </Box>
  );
};

export const ApplicationClusterSection = memo(ApplicationClusterSectionInner);
